import React from 'react';
import { faFile, faGavel } from '@fortawesome/sharp-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography } from '@mui/material';
import { type DisplayedDocument } from '@europrocurement/l2d-modules/modules/Dossiers/providers/types';
import { type FormaliteJsonldFormaliteRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { type DossFormalitiesAndDocsType } from './OrderDuplicateForm';

export type OrderExpandAccordionLabelProps = {
    dossierFormalitiesAndDocs: DossFormalitiesAndDocsType;
    selectedFormalities: FormaliteJsonldFormaliteRead[];
    selectedDocuments: DisplayedDocument[];
};

const OrderExpandAccordionLabel: React.FunctionComponent<OrderExpandAccordionLabelProps> =
    function ({ dossierFormalitiesAndDocs, selectedFormalities, selectedDocuments }) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                    }}
                >
                    <FontAwesomeIcon
                        icon={faGavel}
                        data-testid="formalite-icon"
                    />
                    <Typography>
                        {
                            dossierFormalitiesAndDocs.formalities.filter((f) =>
                                selectedFormalities.some((sf) => sf.id === f.id),
                            ).length
                        }
                        /{dossierFormalitiesAndDocs.formalities.length}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                    }}
                >
                    <FontAwesomeIcon
                        icon={faFile}
                        data-testid="document-icon"
                    />
                    <Typography>
                        {/* Number of documents selected from formalities documents */}
                        {dossierFormalitiesAndDocs.formalities.reduce(
                            (acc, curent) =>
                                acc +
                                (curent.displayedDocs
                                    ? curent.displayedDocs.filter((doc) =>
                                          selectedDocuments.some(
                                              (sd) => sd.documentTypeId === doc.documentTypeId,
                                          ),
                                      ).length
                                    : 0),
                            0,
                        )}
                        /{/* Number of documents in formalities */}
                        {dossierFormalitiesAndDocs.formalities.reduce(
                            (acc, curent) =>
                                acc + (curent.displayedDocs ? curent.displayedDocs.length : 0),
                            0,
                        )}
                    </Typography>
                </Box>
            </Box>
        );
    };

export default OrderExpandAccordionLabel;
